import { ref } from 'vue';
import { nestCall, NestApiType } from '@/composables/nestApi';

export interface GleapNewsItem {
  id: string;
  subject: string;
  coverImageUrl: string | null;
  description: string;
  createdAt: string | null;
}

export const NEWS_ARTICLE_BASE_URL = 'https://roadmap.shopimind.com/news';

export function buildNewsArticleUrl(id: string): string {
  return `${NEWS_ARTICLE_BASE_URL}/${id}`;
}

export function useGleapNews() {
  const news = ref<GleapNewsItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const load = async (limit = 9, lang?: string): Promise<void> => {
    loading.value = true;
    error.value = null;

    const resolvedLang = (lang
      || (typeof navigator !== 'undefined' ? navigator.language : 'en')
      || 'en'
    ).split('-')[0].toLowerCase();

    const result = await nestCall(
      'get',
      NestApiType.DEFAULT,
      '/gleap/news',
      {},
      '',
      undefined,
      false,
      { lang: resolvedLang, limit },
    );

    if (result && !(result as any).error && Array.isArray(result)) {
      news.value = result as GleapNewsItem[];
    } else {
      error.value = (result as any)?.error
        ? String((result as any).error)
        : 'fetch_failed';
      news.value = [];
    }

    loading.value = false;
  };

  return {
    news,
    loading,
    error,
    load,
  };
}
